import { urlReplace } from "helpers/url";
import Api from "./Api";

export default class EventService {
	constructor(api) {
		this.api = api || new Api();
	}

	async getAll(data, params) {
		return this.api.post('/secure/events', data, params);
	}

	async getById(id, params) {
		return this.api.get(urlReplace('/secure/event/{id}', { id: id }), params);
	}

	async create(data, params) {
		return this.api.post('/secure/event/new', data, params);
	}

	async update(id, data, params) {
		return this.api.put(urlReplace('/secure/event/{id}', { id: id }), data, params);
	}

}